$(document).ready(() => {
  let $mobileSidebar = $('.mobile-sidebar');

  $('.sidebar-menu .has-submenu').on('click', '.title', e => {
    let $submenu = $(e.currentTarget).next();
    $submenu.toggle();

    $submenu.parent().siblings('.has-submenu').find('.sidebar-submenu').hide();
  });

  $('.show-mobile-sidebar').click(() => {
    $mobileSidebar.fadeIn();
  });

  $mobileSidebar.on('click', (event) => {
    if (event.currentTarget === event.target) {
      $mobileSidebar.fadeOut();
    }
  });

  $mobileSidebar.on('click', '.close-x', () => {
    $mobileSidebar.fadeOut();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      // close modal here
      if ($mobileSidebar.is(":visible")) {
        $mobileSidebar.fadeOut();
      }
    }
  });

  window.addEventListener('resize', () => {
    if ($mobileSidebar.is(':visible')) {
      $mobileSidebar.hide();
    }
  });
});